import { GQLLedgerLogTypes, GQLPaymentCategories } from "../../../graphqlTypes"

export const PurchaseLogTypeLabels = {
  [GQLLedgerLogTypes.Charge]: "Charge",
  [GQLLedgerLogTypes.EditPurchase]: "Edit Purchase",
  [GQLLedgerLogTypes.Refund]: "Refund",
  [GQLLedgerLogTypes.VoidPurchase]: "Void Purchase",
  [GQLLedgerLogTypes.VoidRefund]: "Void Refund",
  [GQLLedgerLogTypes.RemoveStudentFromLesson]: "Remove student from lesson",
  [GQLLedgerLogTypes.CancelLesson]: "Lesson cancelled",
  [GQLLedgerLogTypes.ScheduleLesson]: "Lesson scheduled",
  [GQLLedgerLogTypes.ExpireProducts]: "Expire products",
  [GQLLedgerLogTypes.VoidExpiration]: "Void expiration",
}

export const PURCHASE_LOG_LABELS_BY_ID = {
  [GQLPaymentCategories.Stripe]: "Stripe",
  [GQLPaymentCategories.Paypal]: "Paypal",
  [GQLPaymentCategories.Voucher]: "Voucher",
  [GQLPaymentCategories.Charter]: "Charter School",
  [GQLPaymentCategories.Corporate]: "Organization",
  [GQLPaymentCategories.CashCheck]: "Cash or Check",
  [GQLPaymentCategories.Complimentary]: "Complimentary",
  [GQLPaymentCategories.Transfer]: "Transfer",
  [GQLPaymentCategories.NotApplicable]: "Not Applicable",
  [GQLPaymentCategories.Acquisition]: "Acquisition",
}

export const DRIVING_MINUTE_PRODUCT_ID = "drivingMinute" as const
export const OBSERVATION_MINUTE_PRODUCT_ID = "observationMinute" as const
export const HOME_PICKUP_PRODUCT_ID = "homePickup" as const

export const minuteProducts: { [key: string]: string } = {
  [DRIVING_MINUTE_PRODUCT_ID]: "Driving Minute",
  [OBSERVATION_MINUTE_PRODUCT_ID]: "Observation Minute",
}

export const CategoryLabels = {
  [GQLPaymentCategories.CashCheck]: "Cash or Check",
  [GQLPaymentCategories.Charter]: "Charter",
  [GQLPaymentCategories.Complimentary]: "Complimentary",
  [GQLPaymentCategories.Corporate]: "Corporate",
  [GQLPaymentCategories.NotApplicable]: "Not Applicable",
  [GQLPaymentCategories.Paypal]: "Paypal",
  [GQLPaymentCategories.Stripe]: "Stripe",
  [GQLPaymentCategories.Transfer]: "Transfer",
  [GQLPaymentCategories.Voucher]: "Voucher",
  [GQLPaymentCategories.Acquisition]: "Acquisition",
}
